import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("privilege/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function update(privilege_id, data) {
  const url = get_api_path("privilege/update", {}, { privilege_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};